import {
  REVIEW_RATING,
  type ReviewRating,
} from "@-/dev.improve.haniverse.lib.cards.user-card.fsrs";
import {
  type SentenceDrillState,
  sentenceDrillRatings,
  sentenceDrillRatingsOnCommit,
} from "@-/dev.improve.haniverse.lib.sentence.drill";

/**
 * The per-word ratings a sentence-production drill commits for a card-level `rate` action.
 *
 * Two situations, one rule set:
 *
 *   * The drill is FINISHED (the learner pressed reveal and is being asked to grade the revealed
 *     word): the existing footer semantics — every produced word is Easy, and the chosen rating
 *     overrides Again on the revealed word(s).
 *   * The drill is UNFINISHED (a swipe or a button ended the attempt mid-sentence): produced words
 *     stay Easy, the word under the cursor takes the chosen rating, and words never reached are
 *     left unrated — see `sentenceDrillRatingsOnCommit`.
 */
export function sentenceDrillCommitReviews(
  state: SentenceDrillState,
  rating: ReviewRating,
): { rating: ReviewRating; tokenIndex: number }[] {
  if (state.isFinished) {
    return sentenceDrillRatings(state).map((wordRating) => ({
      rating: wordRating.rating === "again" ? rating : REVIEW_RATING.Easy,
      tokenIndex: wordRating.tokenIndex,
    }));
  }
  return sentenceDrillRatingsOnCommit({
    currentWordRating: rating,
    ratingFor: (outcome) => (outcome === "again" ? REVIEW_RATING.Again : REVIEW_RATING.Easy),
    state,
  });
}
